<template>
    <div v-bind:class="app_container_class" id="app-container">
        <transition name="content-fade">
            <home-buttons-component />
        </transition>
    </div>

    <div class="print_block" id="print_block" ref="print_block" v-if="this.$root.admin_invoice_loaded === true">
        <component :is="this.$root.invoice_component"  v-bind:invoice="this.$root.current_invoice_to_print" />
    </div>

</template>


<script>
import { defineComponent } from "vue";
import HomeButtons from "./HomeButtons";
import { setApiLocale } from "../../helpers/kiosk-helpers";

export default defineComponent({
    name: "Home",

    beforeCreate() {
        if(this.$route.name === 'home')
        {
            this.$router.push({ name: this.$root.locale + '.home' });
            return;
        }

        setApiLocale(this.$root.locale)
            .then(() => {
                //
            })
            .catch(error => {
                    this.$root.addErrors('a-204',null,String(error));
                });

        window.locale = this.locale;
        this.trans.setLocale(this.locale);
    },

    created() {
        this.$root.global_cancel_btn_disabled = false;

        if(this.$root.app_is_loaded === false)
        {
            this.$root.current_event_is_loaded.push('loading-app');
            this.$root.current_loading_message = this.trans.get('kiosk.loading-home');
        }
    },

    components: {
        'home-buttons-component': HomeButtons,
    },

    data() {
        return {
            app_container_class: 'bg-phoenix-logo justify-content-end',
            invoice_loaded:false,
            invoice_component: null,
            current_invoice_to_print:null,
            logo_press_time:0,
            logo_timer:null,
        }
    },

    emits: {
        'send': () => {
            return true;
        },
    },

    methods: {

        setLocale(locale)
        {
            window.locale = locale;
            this.cookies.set('app_locale', locale);

            this.$forceUpdate();


        },



        switchLocale()
        {
            let new_locale = 'en';

            if(window.locale === 'en')
            {
                new_locale = 'fr';
            }

            this.setLocale(new_locale);
            this.$emit('send', 'switch_locale:' + new_locale);
        }

    },

    mounted() {

    },


})
</script>

<style scoped></style>
